$( document ).ready(function() {
  $(".HorizontalList__Item").hover(function(){
    var heights = $(this).find(".MegaMenu__Inner .MegaMenu__Item").map(function ()
      {
          return $(this).height();
      }).get();

    var maxHeight = Math.max.apply(null, heights);
    $(this).find(".MegaMenu__Inner .MegaMenu__Item").css("min-height", maxHeight);
  });
  
  $(".LogoList__Slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<div class="arrow-left"><img src="//www.gracerosefarm.com/cdn/shop/t/194/assets/arrow-left.png?v=12460553003671917091763503756"></div>',
    nextArrow: '<div class="arrow-right"><img src="//www.gracerosefarm.com/cdn/shop/t/194/assets/arrow-right.png?v=138583861051722036591763503756"></div>',
    responsive: [
      {
        breakpoint: 641,
        settings: {
          rows: 2,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  
  $(".Testimonial__List").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><img src="//www.gracerosefarm.com/cdn/shop/t/194/assets/arrow-left.png?v=12460553003671917091763503756"></div>',
    nextArrow: '<div class="arrow-right"><img src="//www.gracerosefarm.com/cdn/shop/t/194/assets/arrow-right.png?v=138583861051722036591763503756"></div>',
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $(".Member__Slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $(".Member__ArrowLeft").click(function(){
    $(".Member__Slider").slick('slickPrev');
  });
  $(".Member__ArrowRight").click(function(){
    $(".Member__Slider").slick('slickNext');
  });
  
  if($(window).width() < 641){
    $(".FeaturedCollection--grid .Grid").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2
    });
    
    $(".ArticleList__Section .ArticleList").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  $(".BlogFilter__Search .Icon--search").click(function(){
    $(".BlogFilter__Menu li:not(:first-child)").hide();
    $(this).parents(".BlogFilter__Search").find(".Search__Form").css("display", "flex");
  });
  $(".BlogFilter__Search .Icon--close").click(function(){
    $(".BlogFilter__Menu li:not(:first-child)").show();
    $(this).parents(".BlogFilter__Search").find(".Search__Form").css("display", "none");
  });
  
  $("#Form__Date").datepicker({
          minDate: +1
//           maxDate: '+2M',
//           beforeShowDay: $.datepicker.noWeekends
  });
  
  setTimeout(function(){
  $(".ImageHero__VideoMP4 .ImageHero__Overlay").css({"visibility": "inherit", "opacity": "1", "transform": "matrix(1, 0, 0, 1, 0, 0)"});
  }, 500);
  
  $(".ProductItem__Promotional").css("height", $(".ProductList .Grid__Cell:first-child .ProductItem").width());
  
});

$(window).resize(function(){
  $(".ProductItem__Promotional").css("height", $(".ProductList .Grid__Cell:first-child .ProductItem").innerWidth());
});

$(function() {
  $(".PromotionalBanner .btn-close").click(function(){
    $(this).parent().hide();
    $.session.set("PromotionalBanner", "close");
  });
  if($.session.get("PromotionalBanner") == "close"){
    $(".PromotionalBanner").hide();
  }else{
    $(".PromotionalBanner").show();
  }
});

$(function () {
    $(".ProductList .Grid__Cell").slice(0, 12).css("display", "inline-block");
  $(".ProductItem__Promotional").css("height", $(".ProductList .Grid__Cell:first-child .ProductItem").width());
    $("#loadMore").on('click', function (e) {
        e.preventDefault();
        $(".ProductList .Grid__Cell:hidden").slice(0, 12).css("display", "inline-block");
        if ($(".ProductList .Grid__Cell:hidden").length == 0) {
            $(".ProductList--loadMore").fadeOut('slow');
        }
    });
});